import request from '../../request'

export default {
  actions: {
    // list all products
    getOffers(_, parameters) {
      return request.get('offer', {
        params: parameters
      })
    },

    getNotificationById(_, payload) {
      return request.get('get-notification-by-id/' + payload)
    },

    getOffer(_, payload) {
      return request.get('offer-detail/' + payload)
    },

    getDateOffer(_, parameters) {
      return request.get('get-offer-date', {
        params: parameters
      })
    },
    getTotalSms() {
      return request.get('get-sms-total')
    },

    getSmsList(_, page) {
      return request.get('sms-list', {
        params: {
          page: page
        }
      });
    },
    

    // create new product
    createOffer(_, payload) {
      return request.post('offer', payload)
    },

    
    companyUpdateSMSSettings(_, payload) {
      return request.post('sms-setting-kaydet', payload);
    },

    // update product
    updateOffer(_, payload) {
      return request.put('offer/' + payload.id, payload)
    },

    // delete product
    deleteOffer(_, id) {
      return request.delete('offer/' + id)
    },



  }
}
